import { initializeApp } from 'firebase/app';
import { getFunctions } from 'firebase/functions';
import { getAnalytics } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: "tower2-4a8df.firebaseapp.com",
  projectId: "tower2-4a8df",
  storageBucket: "tower2-4a8df.firebasestorage.app",
  messagingSenderId: "796870564953",
  appId: "1:796870564953:web:39a59f7b5054905a69a548",
  measurementId: "G-7YZ0N42081",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const functions = getFunctions(app);
const analytics = getAnalytics(app);

export { app, functions, analytics };
